/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_DeleteInputs */

const en_context_menu_delete = /** @type {(inputs: Context_Menu_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete...`)
};

const fr_context_menu_delete = /** @type {(inputs: Context_Menu_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer...`)
};

const de_context_menu_delete = /** @type {(inputs: Context_Menu_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen...`)
};

const it_context_menu_delete = /** @type {(inputs: Context_Menu_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminare...`)
};

const ru_context_menu_delete = /** @type {(inputs: Context_Menu_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить...`)
};

const es_context_menu_delete = /** @type {(inputs: Context_Menu_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar...`)
};

const zh_cn2_context_menu_delete = /** @type {(inputs: Context_Menu_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除...`)
};

const ja_context_menu_delete = /** @type {(inputs: Context_Menu_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消去...`)
};

const hi_context_menu_delete = /** @type {(inputs: Context_Menu_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मिटाना...`)
};

const pt_pt2_context_menu_delete = /** @type {(inputs: Context_Menu_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir...`)
};

/**
* | output |
* | --- |
* | "Delete..." |
*
* @param {Context_Menu_DeleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_delete = /** @type {((inputs?: Context_Menu_DeleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_DeleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_delete(inputs)
	if (locale === "de") return de_context_menu_delete(inputs)
	if (locale === "it") return it_context_menu_delete(inputs)
	if (locale === "ru") return ru_context_menu_delete(inputs)
	if (locale === "es") return es_context_menu_delete(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_delete(inputs)
	if (locale === "ja") return ja_context_menu_delete(inputs)
	if (locale === "hi") return hi_context_menu_delete(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_delete(inputs)
	return en_context_menu_delete(inputs)
});